module.exports = __webpack_public_path__ + "img/LicorAperol.b8fc3407.jpg";